var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 228,
    height: 144,
    viewBox: "0 0 228 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_888",
    "data-name": "Group 888",
    transform: "translate(-915.921 34)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Shafaq_waqas",
    "data-name": "Shafaq waqas",
    transform: "translate(1034.921 105)",
    fontSize: 28,
    fontFamily: "Ubuntu-Medium, Ubuntu",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -108,
    y: 0
  }, "SHAFAQ WAQAS")), /*#__PURE__*/React.createElement("text", {
    id: "SW",
    transform: "translate(915.921 58)",
    fontSize: 108,
    fontFamily: "EdwardianScriptITC, Edwardian Script ITC"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SW")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer-logo.bc97078ff6b542771c23561596b1e319.svg";
export { ForwardRef as ReactComponent };